import { ParticipantTracks } from '../ParticipantTracks';
import { useMainParticipant, useScreenShareParticipant, useSelectedParticipant, useVideo } from 'hooks';
import { MainParticipantInfo } from '../MainParticipantInfo';

type MainParticipantProps = {
  className?: string;
  zoomScale?: number;
  panOffset?: {
    x: number;
    y: number;
  };
  showZoomRail?: boolean;
  enableZoomPan?: boolean;
  zoomLevel?: number;
  onZoomLevelChange?: (value: number) => void;
  onPanOffsetChange?: (value: { x: number; y: number }) => void;
};

export function MainParticipant({
  className,
  zoomScale,
  panOffset,
  showZoomRail,
  enableZoomPan,
  zoomLevel,
  onZoomLevelChange,
  onPanOffsetChange,
}: MainParticipantProps) {
  const { room } = useVideo();

  const mainParticipant = useMainParticipant();
  const localParticipant = room!.localParticipant;
  const [selectedParticipant] = useSelectedParticipant();
  const screenShareParticipant = useScreenShareParticipant();

  const videoPriority =
    (mainParticipant === selectedParticipant || mainParticipant === screenShareParticipant) &&
    mainParticipant !== localParticipant
      ? 'high'
      : null;

  /* audio is disabled for this participant component because this participant's audio
       is already being rendered in the <ParticipantStrip /> component.  */
  return (
    <MainParticipantInfo
      className={className}
      participant={mainParticipant}
      showZoomRail={showZoomRail}
      enableZoomPan={enableZoomPan}
      zoomLevel={zoomLevel}
      onZoomLevelChange={onZoomLevelChange}
      zoomScale={zoomScale}
      panOffset={panOffset}
      onPanOffsetChange={onPanOffsetChange}
    >
      <ParticipantTracks
        participant={mainParticipant}
        videoOnly
        enableScreenShare={true}
        videoPriority={videoPriority}
        isLocalParticipant={mainParticipant === localParticipant}
        zoomScale={zoomScale}
        panOffset={panOffset}
        canPan={enableZoomPan}
      />
    </MainParticipantInfo>
  );
}
